// TODO remove when removing stubbed data
/* eslint-disable typescript/ban-ts-comment */
// @ts-nocheck

import {useQuery} from "@apollo/client";
import {useMemo} from "react";

import {useFilteredRowSelection} from "@/components/table/hooks/useFilteredRowSelection.ts";
import {useTable} from "@/lib/hooks/useTable.ts";
import {ActiveOccurrencesListResponse, GQL_MAINTENANCE_OCCURRENCES_LIST} from "@/lib/queries/maintenance.ts";
import {MaintenanceOccurrenceStatus} from "@/lib/types/maintenance.ts";
import {ActiveOccurrencesTable} from "@/pages/maintenance/maintenance-dashboard/tabs/active-occurrences/ActiveOccurrencesTable/ActiveOccurrencesTable.tsx";
import {ActiveOccurrencesControlBar} from "@/pages/maintenance/maintenance-dashboard/tabs/active-occurrences/ActiveOccurrencesTable/components/ActiveOccurrencesControlBar.tsx";
import {TableBulkActionsBar} from "@/pages/maintenance/maintenance-dashboard/tabs/active-occurrences/ActiveOccurrencesTable/components/TableBulkActionsBar.tsx";

const SESSION_STORAGE_FILTERS_KEY = "active_occurrences_list_filters";

export const ActiveOccurrencesTab = () => {
  const {
    search,
    searchDebounced,
    searchChanged,
    pagination,
    setPagination,
    sorting,
    setSorting,
    sortingString,
    filterSets,
    setFilterSets,
  } = useTable({
    sessionStorageKey: SESSION_STORAGE_FILTERS_KEY,
    resetPaginationOnFilter: true,
    filtersKey: SESSION_STORAGE_FILTERS_KEY,
  });

  const {data, previousData, loading} = useQuery<ActiveOccurrencesListResponse>(GQL_MAINTENANCE_OCCURRENCES_LIST, {
    variables: {
      ...pagination,
      sort: sortingString,
      search: searchDebounced,
      filters: {...filterSets, ...{occurrence_status: [MaintenanceOccurrenceStatus.ACTIVE]}},
    },
    fetchPolicy: "network-only",
  });

  const responseData = data?.response || previousData?.response;
  const items = useMemo(() => responseData?.items ?? [], [responseData]);

  const {rowSelection, setRowSelection} = useFilteredRowSelection({
    data: items,
    getRowId: (row) => String(row.id),
  });

  return (
    <>
      <ActiveOccurrencesControlBar
        search={search}
        setSearch={searchChanged}
        filterSets={filterSets}
        onFilterSetChange={setFilterSets}
      />
      <ActiveOccurrencesTable
        data={responseData}
        sortColumn={sorting.column}
        sortDirection={sorting.direction}
        onSortingChange={setSorting}
        pagination={pagination}
        setPagination={setPagination}
        isFiltered={!!searchDebounced || Object.keys(filterSets).length > 0}
        loading={loading}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
        actionBar={
          <TableBulkActionsBar occurrences={items} selectedItems={rowSelection} setSelectedItems={setRowSelection} />
        }
      />
    </>
  );
};
